import { Product } from '@/interfaces/Product'
import { Attribute } from '@/interfaces/Attribute'

export class ProductDetail {
  id: number
  name: string
  description: string
  price: number
  currency: string
  cover: string | null = null
  image: string | null = null
  color: string | null = null
  attributes: { [key: string]: Attribute }
  otherAttributeKey?: string
  isBase: boolean
  sku: string
  idPrestashopProduct: number
  idPrestashopAttribute: number

  get formattedPrice (): string {
    return this.price.toFixed(2) + ' ' + this.currency
  }

  get coverImage (): string | null {
    return this.cover ?? this.image
  }

  constructor (product: Product, isBase = false, idPrestashopMaster: number | null) {
    this.id = product.productId
    this.name = product.name
    this.description = product.description
    this.currency = product.currency
    this.price = product.price
    this.attributes = {}
    this.isBase = isBase
    this.image = product.image
    this.cover = product.cover ?? null
    this.sku = product.sku

    if (idPrestashopMaster == null) {
      this.idPrestashopProduct = product.idPrestashop
      this.idPrestashopAttribute = 0
    } else {
      this.idPrestashopProduct = idPrestashopMaster
      this.idPrestashopAttribute = product.idPrestashop
    }

    for (const attribute of product.attributes) {
      if (attribute.key === 'Colore') {
        this.color = attribute.color
      } else {
        this.otherAttributeKey = attribute.key
      }
      this.attributes[attribute.key] = attribute
    }
  }
}
